import { Injectable } from '@angular/core';
import { CanActivate, NavigationExtras, Router } from '@angular/router';
import { apisDataCacheKeys } from '@app-constants/app.constants';
import { TenantConstant } from '@app-constants/tenant.constant';
import { UserService } from '@app-services/user/user.service';
@Injectable({
  providedIn: 'root',
})
export class ProfileGuard implements CanActivate {
  tenant : any = TenantConstant.tenant;
  constructor(public router: Router, private userService: UserService) {}

  canActivate(): boolean {

    let profInfo: any = localStorage.getItem(apisDataCacheKeys.userDetails);
    if(!profInfo) return true;
    profInfo = JSON.parse(profInfo);
    profInfo = profInfo || {};
    const isProfileComplete = profInfo.grade && profInfo.exams.length > 0;
    const userTypeID = this.userService.getUserType()
    if (this.tenant != 'srichaitanya' && userTypeID == 1 && !isProfileComplete) {
      const navigationExtras: NavigationExtras = {
        state: {
          setupAccountImposed: true
        }
      };
      this.router.navigate(['target-exam'], navigationExtras);
      return false;
    }
    return true;
  }
}
